<template>
  <div>
      <div class="not-found">
          <span>404</span>
          <p>Page Not Found</p>
      </div>
      
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

    .not-found{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        opacity: 0.5;
    }

    .not-found span{
        font-size: 150px;
        font-weight: bold;
        color: #6454f0 ;
    }

    .not-found p{
        font-size: 36px;
        margin-top: -53px;
        color: #6454f0 ;
    }

</style>